import { Page } from '@/core/architecture'

import { StoreRequestProvidableItemSearchTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * StoreRequestProvidableItemSearch Page
 * Implemented as a practical sample.
 */
export const StoreRequestProvidableItemSearch: Page = () => {
  const { state, actions } = useViewModel()

  return <StoreRequestProvidableItemSearchTemplate state={state} {...actions} />
}
